import React, { FC } from 'react';
import { TooltipProps } from 'antd/lib/tooltip';

import { StyledTooltip } from './styled';

export const WhiteTooltip: FC<TooltipProps> = props => <StyledTooltip color='white' {...props} />;
